import React from "react";
import { Button } from "@mui/material";

const DSSecondaryButton = (props: React.ComponentProps<typeof Button>) => {
  return <Button color="secondary" variant="outlined" {...props} />;
};

export default DSSecondaryButton;
